import Indicator from './Indicator';

export default Indicator;
